import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EditionConcours } from '../classes/editionConcours';

@Injectable({
  providedIn: 'root'
})
export class EditionConcoursService {
  public allEditions = [];
  public isCame = false;

  constructor(
    private firestore: AngularFirestore,
    // private mytools: UtilService,
  ) { }



  getActiveEdition() {
    return this.firestore.collection('editions-concours', ref =>
      ref.where('statut', '==', true)
    ).valueChanges().pipe(
      map((editions: EditionConcours[]) => editions[0])
    );
  }




}
